import { Link } from 'react-router-dom';
import { Section, SectionHeading } from '../layout/Section.jsx';

/**
 * The store, in its own words, between two shelves.
 *
 * Name, tagline and description all come from the store settings, and the
 * description is split on blank lines so an operator can write more than one
 * paragraph without knowing any markup. With no description set there is
 * nothing to say, and the block steps aside.
 */
export const BrandStory = ({ store = {}, className }) => {
  const paragraphs = String(store.description ?? '')
    .split(/\n\s*\n|\r\n\s*\r\n/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);

  if (!paragraphs.length) return null;

  return (
    <Section className={className}>
      <SectionHeading eyebrow={store.tagline || 'About the store'} title={store.name || 'Our story'} />
      <div className="mx-auto max-w-4xl space-y-4 text-center text-sm leading-relaxed text-muted">
        {paragraphs.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </div>
      <p className="mt-6 text-center">
        <Link
          to="/about"
          className="text-2xs font-medium tracking-[0.12em] text-brand uppercase hover:text-brand-dark focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand"
        >
          Read our story
          <span aria-hidden="true" className="ml-1.5">
            →
          </span>
        </Link>
      </p>
    </Section>
  );
};

export default BrandStory;
